import { render, staticRenderFns } from "./PlatformLogos.vue?vue&type=template&id=df627596&scoped=true"
import script from "./PlatformLogos.vue?vue&type=script&lang=js"
export * from "./PlatformLogos.vue?vue&type=script&lang=js"
import style0 from "./PlatformLogos.vue?vue&type=style&index=0&id=df627596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df627596",
  null
  
)

export default component.exports